import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { SetUpDeviceU2f } from '@app/modules/mfaToken/components';
import { loginForms } from '@app/enums';
import { u2fTest } from '@app/modules/mfaToken/helpers';
import { SetLoginForm } from '@app/models';
import { useTypedTranslation } from '@app/hooks';
import { MfaTestSuccess } from './';

interface IProps {
    isMultipleProviders: boolean;
    setLoginForm: SetLoginForm;
}

export function U2fTest({ isMultipleProviders, setLoginForm }: IProps) {
    const { translation } = useTypedTranslation();

    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    return (
        <>
            {isSuccess ? (
                <MfaTestSuccess
                    setIsSuccess={setIsSuccess}
                    textSuccess={translation('MFA_U2F_VERIFICATION_SUCCESS_DESC_TEST')}
                />
            ) : (
                <SetUpDeviceU2f
                    registrationCallback={u2fTest(() => {
                        setIsSuccess(true);
                    })}
                />
            )}
            {isMultipleProviders && (
                <Button
                    id='signin-select-another-provider'
                    color='default'
                    onClick={() => {
                        setLoginForm(loginForms.twoFactorList);
                    }}
                >
                    {translation('SIGNIN_SELECT_ANOTHER_PROVIDER')}
                </Button>
            )}
        </>
    );
}
